import { useEffect, useRef, useState } from "react";

const stats = [
  { value: 50000, suffix: "+", label: "影视资源库" },
  { value: 980, suffix: "万", label: "日活跃用户" },
  { value: 99.8, suffix: "%", label: "播放成功率", decimal: true },
  { value: 365, suffix: "天", label: "全年每日更新" },
];

export default function StatsSection() {
  const [counts, setCounts] = useState([0, 0, 0, 0]);
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const animated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !animated.current) {
          animated.current = true;
          setVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!visible) return;

    const intervals = stats.map((stat, i) => {
      const target = stat.decimal ? stat.value * 10 : stat.value;
      const duration = 2000;
      const steps = 40;
      const increment = target / steps;
      let current = 0;

      const timer = setInterval(() => {
        current += increment;
        if (current >= target) {
          setCounts((prev) => {
            const next = [...prev];
            next[i] = target;
            return next;
          });
          clearInterval(timer);
        } else {
          setCounts((prev) => {
            const next = [...prev];
            next[i] = Math.floor(current);
            return next;
          });
        }
      }, duration / steps);

      return timer;
    });

    return () => intervals.forEach(clearInterval);
  }, [visible]);

  return (
    <section ref={ref} className="bg-background-100 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-6 text-center">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            蓝莓影院·数据说话
          </h2>
          <p className="text-sm text-foreground-500 mt-1">千万用户信赖的免费观影平台</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat, i) => {
            const displayValue = stat.decimal ? (counts[i] / 10).toFixed(1) : counts[i].toLocaleString();
            return (
              <div key={i} className="text-center p-5 rounded-xl bg-background-50">
                <div className="text-2xl md:text-3xl font-bold text-accent-500 font-heading mb-1">
                  {displayValue}{stat.suffix}
                </div>
                <p className="text-xs md:text-sm text-foreground-600">{stat.label}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}